/**
 * A role Lord é o id 1 na tabela `roles` (RolesTableSeeder), e o id vem na
 * coluna `role` do usuário — já presente no payload do login e decodificado
 * no store.
 *
 * A checagem aqui é só de tela; o backend precisa barrar de novo quem burlar.
 */
export const ROLE_LORD = 1;

export const lordRoleMixin = {
  computed: {
    isLord() {
      const user = this.$store.getters.currentUser;

      return Boolean(user) && Number(user.role) === ROLE_LORD;
    },
  },
};
